import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';

import { useDeleteClip } from '../api/delete-clips';

export function useClipController() {
  const { setClipItems } = useBroadcastScheduleProgram();
  const { mutateAsync } = useDeleteClip();
  const clipDialog = useDisclosureWithData<string>();
  const clipRelaunchDialog = useDisclosureWithData<string>();

  const handleDeleteClip = async (id: string) => {
    try {
      await mutateAsync({ id });
      setClipItems(prev => {
        if (!prev) return prev;
        return prev.filter(item => item.id !== id);
      });
    } catch (error) {
      console.error('Error deleting clip:', error);
    }
  };

  return {
    clipDialog,
    clipRelaunchDialog,
    handleDeleteClip,
  };
}
